export class SendRequest {
  constructor(props) {
    this.props = props;
  }

  hostName() {
    return (window.location.host.split('.')?.[0])
  }

  customHeaderJSON() {
    return {
      'SLUG': this.hostName(),
      'Content-Type': 'application/json'
    }
  }

  serverSideHeaderJSON(hostName) {
    return {
      'SLUG': hostName,
      'Content-Type': 'application/json'
    }
  }

  onlyHeaders(){
    let headers = { 'Content-Type': 'application/json' }
    if (typeof window != "undefined" && (window.location.pathname.startsWith('/clients') || window.location.pathname.startsWith('/agency'))) headers.SLUG = this.hostName();
    return headers
  }

  setHeaderJSON() {
    let headers = { 'Content-Type': 'application/json' }
    if (typeof window != "undefined" && (window.location.pathname.startsWith('/clients') || window.location.pathname.startsWith('/agency'))) headers.SLUG = this.hostName();
    return ({
      headers: headers,
      timeout: 10*60*1000
    });
  }

  setCustomHeaderJSON(slug) {
    let headers = { 'Content-Type': 'application/json' }
    headers.SLUG = slug;
    return ({
      headers: headers
    });
  }


  setCustomHeaderFileDownloadJSON() {
    let headers = { 'Content-Type': 'application/json' }
    if (typeof window != "undefined" && window.location.pathname.startsWith('/clients')) headers.SLUG = this.hostName();
    return ({
      headers: headers,
      responseType: 'blob',
    });
  }

  setMultipartHeaderJSON() {
    return ({
      headers: {
        'SLUG': this.hostName(),
        'Content-Type': 'multipart/form-data'

      },
    });
  }

  setMultipartAndApplicationHeaderJSON() {
    return ({
      headers: {
        'Content-Type': 'multipart/form-data; boundary=something'
      }
    })
  }
  setCredentialsJSON() {
    return ({ withCredentials: true });
  }

  setCrossDomainTrue() {
    return ({ crossDomain: true });
  }

}
